<template>
  <textarea :id="id" :value="value"></textarea>
</template>
<script>
// Import TinyMCE
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/silver/theme';
import 'tinymce/plugins/image';
import 'tinymce/plugins/imagetools';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
// import 'tinymce/plugins/code';
import 'tinymce/icons/default';
import Axios from 'axios';
import { TOKEN_KEY } from '@/libs/util';

const INIT = 0;
const CHANGED = 2;
export default {
  props: {
    value: {
      type: String,
      default: '',
      editor: null
    },
    setting: {}
  },
  watch: {
    value: function (val) {
      if (this.editor) {
        if (this.status === INIT || this.editor.getContent() !== val) {
          this.editor.setContent(val || '');
        }
      }
      this.status = CHANGED;
    }
  },
  data: function () {
    return {
      status: INIT,
      id: `editor${this._uid}`
    };
  },
  methods: {},
  mounted: function () {
    const _this = this;

    const setting = {
      selector: '#' + _this.id,
      language: 'zh_CN',
      forced_root_block: true,
      height: 600,
      content_style: 'img {max-width:100% !important;height:auto}',
      init_instance_callback: function (editor) {
        _this.editor = editor;
        _this.status = CHANGED;
        if (_this.value) {
          editor.setContent(_this.value);
        }
        editor.on('input change undo redo keyup', () => {
          var content = editor.getContent();
          _this.$emit('input', content);
        });
        editor.on('keydown', function (event) {
          if (event.keyCode === 9 || event.keyCode === 32) {
            // tab pressed
            editor.execCommand('mceInsertContent', false, '&emsp;'); // inserts tab
            event.preventDefault();
            return false;
          }
        });
      },
      file_picker_callback: (fn, value, meta) => {
        var input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');

        input.onchange = function (e) {

          var file = this.files[0];
          console.log(6666, file);

          var reader = new FileReader();
          reader.readAsArrayBuffer(file);
          reader.onload = ev => {
            const binary = new Blob([ev.target.result]);
            const formData = new FormData();
            formData.append('file', binary);
            Axios.post(_this.$uploader.action, formData, {
              headers: {
                'Content-type': 'multipart/form-data',
                Authorization: 'Bearer ' + sessionStorage.getItem(TOKEN_KEY),
                responseType: 'blob'
              }
            }).then(
              res => {
                if (res.data.code === 200) {
                  fn(res.data.data.url);
                }
              },
              err => {
                console.log(err);
              }
            );
          };
        };

        input.click();
      },
      file_picker_types: 'image',
      plugins: ['image paste code'],
      toolbar:
        'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | image',
      image_description: false
    };
    if (process.env.NODE_ENV === 'development') {
      Object.assign(setting, _this.setting);
    } else {
      Object.assign(
        setting,
        {
          language_url: '/enterprise_web/langs/zh_CN.js',
          skin_url: '/enterprise_web/skins/ui/oxide',
          content_css: '/enterprise_web/skins/content/default/content.css'
        },
        _this.setting
      );
    }
    setTimeout(() => {
      tinymce.init(setting);
    }, 20);
  },
  beforeDestroy: function () {
    tinymce.get(this.id).destroy();
  }
};
</script>
